import React, { useCallback, useEffect, useState } from "react";
import Logo from "../../assets/images/curenza-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faSuitcase,
  faBars,
  faUser,
  faChevronUp,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../context/UserContext";
import Cookies from "js-cookie";
import { Sidebar } from "primereact/sidebar";
import ProfileImage from "../../assets/icons/profile.png";
import MyService from "../../assets/icons/my-service.png";
import MyQuotesImage from "../../assets/icons/myquotes.png";
import doument from "../../assets/icons/Documents.png";
import ongoing from "../../assets/icons/ongoing.png";
import {
  fetchCategories,
  fetchSubCategories,
  fetchSubCategoriesByCategory,
} from "../../services/CategorySubCategoryService";
import { handleErrors } from "../../utils/errorHandler";
const Header = () => {
  const navigate = useNavigate();
  const { user, setAuthentication } = useUser();
  const [navSidebar, setNavSidebar] = useState(false);
  const [showConnect, setShowConnect] = useState(false);
  const [showConsult, setShowConsult] = useState(false);
  const [openSubIndex, setOpenSubIndex] = useState(null);
  const [openConsultIndex, setOpenConsultIndex] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subCategoriesData, setSubCategoriesData] = useState([]);

  const checkLoginStatus = useCallback(() => {
    const accessToken = Cookies.get("accessToken");
    if (accessToken) {
      setAuthentication(!!accessToken);
    } else {
      setAuthentication(null);
    }
  }, []);
  useEffect(() => {
    checkLoginStatus();
  }, [checkLoginStatus]);
  const handleLogout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("userRole");
    setAuthentication(null);
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    const fetchCategoriesData = async () => {
      try {
        const categoriesData = await fetchCategories();
        console.log("categoriesData", categoriesData.result);
        setCategories(categoriesData.result);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchCategoriesData();
  }, []);

  useEffect(() => {
    const fetchCategoriesData = async (id) => {
      try {
        const subCategoriesData = await fetchSubCategories();
        setSubCategoriesData(subCategoriesData.result);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchCategoriesData();
  }, []);

  const formattedCategory = (category) =>
    category.replace(/&/g, "$").replace(/ /g, "-").toLowerCase();
  const toParam = (value) =>
    value?.replace(/&/g, "$").replace(/ /g, "-").toLowerCase();

  return (
    <>
      <section className="sliding-strip">
        <div className="marquee-content-wrap">
          <p>
            20% off For New Customers.{" "}
            <Link to={"/services"}>Book Service Now</Link>
          </p>
          <p>
            20% off For New Customers.{" "}
            <Link to={"/services"}>Book Service Now</Link>
          </p>
          <p>
            20% off For New Customers.{" "}
            <Link to={"/services"}>Book Service Now</Link>
          </p>
          <p>
            20% off For New Customers.{" "}
            <Link to={"/services"}>Book Service Now</Link>
          </p>
          <p>
            20% off For New Customers.{" "}
            <Link to={"/services"}>Book Service Now</Link>
          </p>
        </div>
      </section>
      <header className="header">
        <div className="container">
          <div className="header-row">
            <div className="header-left">
              <div className="logo">
                <Link to={"/"}>
                  <img src={Logo} alt="" />
                </Link>
              </div>
              <div className="main-menu">
                <ul className="menu-wrap">
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li className="has-dropdown">
                    <Link to="/services">
                      Connect <FontAwesomeIcon icon={faChevronDown} />
                    </Link>
                    <div className="mega-menu professional-menu">
                      <div className="container">
                        <div className="d-flex inner">
                          <div className="links-wrap">
                            {categories?.map((cat, index) => (
                              <div
                                className="list-links"
                                key={`main-category-${index}`}
                              >
                                <div className="list-link-title">
                                  <h4>
                                    <Link
                                      to={`/services?category=${formattedCategory(
                                        cat.categoryName
                                      )}`}
                                    >
                                      {cat.categoryName}
                                    </Link>
                                  </h4>
                                  <ul className="list-columns">
                                    {subCategoriesData
                                      .filter(
                                        (item) => item.categoryId === cat.id
                                      )
                                      .map((sub, index) => (
                                        <li key={`sub-cat-${index}`}>
                                          <Link
                                            to={`/services?subCategory=${formattedCategory(
                                              sub.subCategoryName
                                            )}`}
                                          >
                                            {sub.subCategoryName}
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="has-dropdown">
                    <Link to="/consult">
                      Consult <FontAwesomeIcon icon={faChevronDown} />
                    </Link>
                    <div className="mega-menu professional-menu">
                      <div className="container">
                        <div className="d-flex inner">
                          <div className="links-wrap">
                            <div className="list-links">
                              <div className="list-link-title">
                                <h4>
                                  <Link
                                    to={`/consult?guide=Infrastructure And Utility Management`}
                                  >
                                    Infrastructure & Utility Management
                                  </Link>
                                </h4>
                                <ul className="list-columns">
                                  <li>
                                    <Link
                                      to={`/consult?guide=Electrical And Mechanical Services`}
                                    >
                                      Electrical & Mechanical Services
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Water And Waste Management`}
                                    >
                                      Water & Waste Management
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Fire And Safety Services`}
                                    >
                                      Fire & Safety Services
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="list-links">
                              <div className="list-link-title">
                                <h4>
                                  <Link
                                    to={`/consult?guide=Facility And Property Management`}
                                  >
                                    Facility & Property Management
                                  </Link>
                                </h4>
                                <ul className="list-columns">
                                  <li>
                                    <Link
                                      to={`/consult?guide=Structural And Civil Works`}
                                    >
                                      Structural & Civil Works
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Plumbing And Related Services`}
                                    >
                                      Plumbing & Related Services
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=HVAC And Environmental Solutions`}
                                    >
                                      HVAC & Environmental Solutions
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Lifts And Accessibility Services`}
                                    >
                                      Lifts & Accessibility Services
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="list-links">
                              <div className="list-link-title">
                                <h4>
                                  <Link
                                    to={`/consult?guide=Lifestyle And Residential Services`}
                                  >
                                    Lifestyle & Residential Services
                                  </Link>
                                </h4>
                                <ul className="list-columns">
                                  <li>
                                    <Link
                                      to={`/consult?guide=Community And Event Services`}
                                    >
                                      Community & Event Services
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Housekeeping And Maintenance`}
                                    >
                                      Housekeeping & Maintenance
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Fitness And Recreation`}
                                    >
                                      Fitness & Recreation
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Gardening And Landscaping`}
                                    >
                                      Gardening & Landscaping
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="list-links">
                              <div className="list-link-title">
                                <h4>
                                  <Link
                                    to={`/consult?guide=Specialized And Emergency Services`}
                                  >
                                    Specialized & Emergency Services
                                  </Link>
                                </h4>
                                <ul className="list-columns">
                                  <li>
                                    <Link
                                      to={`/consult?guide=Animal And Pest Services`}
                                    >
                                      Animal & Pest Services
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/consult?guide=Repair And Emergency Solutions`}
                                    >
                                      Repair & Emergency Solutions
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <Link to="/blogs">Blogs</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="header-right">
              <div className="buttons-wrap">
                <Link to="/careers" className="join-us">
                  Join Us
                </Link>
                {!user?.isAuthenticated && (
                  <>
                    <Link
                      to={"/vendor-login"}
                      className="btn vendor-login d-lg-block d-none"
                    >
                      <FontAwesomeIcon icon={faSuitcase} />{" "}
                      <span>For Vendors</span>
                    </Link>
                    <Link
                      to={"/login"}
                      className="btn customer-login  orange-outlined d-lg-block d-none"
                    >
                      <FontAwesomeIcon icon={faUser} />{" "}
                      <span>For Customers</span>
                    </Link>
                  </>
                )}
              </div>
              <ul className="nav header-navbar-rht">
                <li className="swr-menu">
                  <div
                    className="menu-icon"
                    onClick={() => setNavSidebar(true)}
                  >
                    <FontAwesomeIcon icon={faBars} />
                  </div>

                  <Sidebar
                    visible={navSidebar}
                    position="right"
                    onHide={() => setNavSidebar(false)}
                    className="nav-sidebar"
                  >
                    <div className="sidebar-top-menu-wrap">
                      <div
                        className="wrap"
                        onClick={() => setNavSidebar(false)}
                      >
                        {user?.isAuthenticated &&
                          user?.userRole === "Owner" && (
                            <ul className="swr-user-menu">
                              <li>
                                <Link to="my-account/profile">
                                  <img src={ProfileImage} alt="" /> My Profile
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/ongoing-booking">
                                  <img src={MyService} alt="" /> Ongoing
                                  Bookings
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/complete-booking">
                                  <img src={ongoing} alt="" /> Completed
                                  Bookings
                                </Link>
                              </li>
                            </ul>
                          )}
                        {user?.isAuthenticated &&
                          user?.userRole === "Vendor" && (
                            <ul className="swr-user-menu">
                              <li>
                                <Link to="vendor-account/vendor-profile">
                                  <img src={ProfileImage} alt="" /> My Profile
                                </Link>
                              </li>
                              <li>
                                <Link to="vendor-account/vendor-doument">
                                  <img src={doument} alt="" /> Business Info
                                </Link>
                              </li>
                              <li>
                                <Link to="vendor-account/vendor-ongoings">
                                  <img src={MyService} alt="" /> Ongoings
                                  Bookings
                                </Link>
                              </li>
                              <li>
                                <Link to="vendor-account/vendor-comnpleted">
                                  <img src={ongoing} alt="" /> Completed
                                  Bookings
                                </Link>
                              </li>
                              <li>
                                <Link to="vendor-account/my-quotes">
                                  <img src={MyQuotesImage} alt="" /> My Quotes
                                </Link>
                              </li>
                            </ul>
                          )}
                        <ul className="ser-main-menu">
                          <div className="list-links d-xl-none">
                            {/* Top-level Connect toggle */}
                            <div
                              className="list-link-title"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowConnect(!showConnect);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <h6>Connect</h6>
                              <FontAwesomeIcon
                                icon={showConnect ? faChevronUp : faChevronDown}
                              />
                            </div>

                            {/* First dropdown: Connect options */}
                            {showConnect && (
                              <ul className="list-columns">
                                {/* Item 1 with nested dropdown */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenSubIndex(
                                        openSubIndex === 1 ? null : 1
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/services?category=${toParam(
                                        "Infrastructure & Utility Management"
                                      )}`}
                                    >
                                      Infrastructure & Utility Management
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openSubIndex === 1 ? faMinus : faPlus
                                      }
                                    />
                                  </div>

                                  {/* Nested submenu */}
                                  {openSubIndex === 1 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Electrical & Mechanical Services"
                                          )}`}
                                        >
                                          Electrical & Mechanical Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Water & Waste Management"
                                          )}`}
                                        >
                                          Water & Waste Management
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Fire & Safety Services"
                                          )}`}
                                        >
                                          Fire & Safety Services
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>

                                {/* Item 2 (no submenu) */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenSubIndex(
                                        openSubIndex === 2 ? null : 2
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/services?category=${toParam(
                                        "Facility & Property Management"
                                      )}`}
                                    >
                                      Facility & Property Management
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openSubIndex === 2 ? faMinus : faPlus
                                      }
                                    />
                                  </div>
                                  {openSubIndex === 2 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Structural & Civil Works"
                                          )}`}
                                        >
                                          Structural & Civil Works
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Plumbing & Related Services"
                                          )}`}
                                        >
                                          Plumbing & Related Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "HVAC & Environmental Solutions"
                                          )}`}
                                        >
                                          HVAC & Environmental Solutions
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Lifts & Accessibility Services"
                                          )}`}
                                        >
                                          Lifts & Accessibility Services
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>

                                {/* Item 3 (no submenu) */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenSubIndex(
                                        openSubIndex === 3 ? null : 3
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/services?category=${toParam(
                                        "Lifestyle & Residential Services"
                                      )}`}
                                    >
                                      Lifestyle & Residential Services
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openSubIndex === 3 ? faMinus : faPlus
                                      }
                                    />
                                  </div>
                                  {openSubIndex === 3 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Community & Event Services"
                                          )}`}
                                        >
                                          Community & Event Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Housekeeping & Maintenance"
                                          )}`}
                                        >
                                          Housekeeping & Maintenance
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Fitness & Recreation"
                                          )}`}
                                        >
                                          Fitness & Recreation
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Gardening & Landscaping"
                                          )}`}
                                        >
                                          Gardening & Landscaping
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>

                                {/* Item 4 (no submenu) */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenSubIndex(
                                        openSubIndex === 4 ? null : 4
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/services?category=${toParam(
                                        "Specialized & Emergency Services"
                                      )}`}
                                    >
                                      Specialized & Emergency Services
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openSubIndex === 4 ? faMinus : faPlus
                                      }
                                    />
                                  </div>
                                  {openSubIndex === 4 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Animal & Pest Services"
                                          )}`}
                                        >
                                          Animal & Pest Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Repair & Emergency Solutions"
                                          )}`}
                                        >
                                          Repair & Emergency Solutions
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/services?subCategory=${toParam(
                                            "Professional Services"
                                          )}`}
                                        >
                                          Professional Services
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>
                              </ul>
                            )}
                          </div>
                          <div className="list-links d-xl-none">
                            {/* Top-level Connect toggle */}
                            <div
                              className="list-link-title"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowConsult(!showConsult);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <h6>Consult</h6>
                              <FontAwesomeIcon
                                icon={showConsult ? faChevronUp : faChevronDown}
                              />
                            </div>

                            {/* First dropdown: Connect options */}
                            {showConsult && (
                              <ul className="list-columns">
                                {/* Item 1 with nested dropdown */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenConsultIndex(
                                        openConsultIndex === 1 ? null : 1
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/consult?guide=Infrastructure & Utility Management`}
                                    >
                                      Infrastructure & Utility Management
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openConsultIndex === 1
                                          ? faMinus
                                          : faPlus
                                      }
                                    />
                                  </div>

                                  {/* Nested submenu */}
                                  {openConsultIndex === 1 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/consult?guide=Electrical & Mechanical Services`}
                                        >
                                          Electrical & Mechanical Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Water & Waste Management`}
                                        >
                                          Water & Waste Management
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Fire & Safety Services`}
                                        >
                                          Fire & Safety Services
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>

                                {/* Item 2 (no submenu) */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenConsultIndex(
                                        openConsultIndex === 2 ? null : 2
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/consult?guide=Facility & Property Management`}
                                    >
                                      Facility & Property Management
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openConsultIndex === 2
                                          ? faMinus
                                          : faPlus
                                      }
                                    />
                                  </div>
                                  {openConsultIndex === 2 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/consult?guide=Structural & Civil Works`}
                                        >
                                          Structural & Civil Works
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Plumbing & Related Services`}
                                        >
                                          Plumbing & Related Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=HVAC & Environmental Solutions`}
                                        >
                                          HVAC & Environmental Solutions
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Lifts & Accessibility Services`}
                                        >
                                          Lifts & Accessibility Services
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>

                                {/* Item 3 (no submenu) */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenConsultIndex(
                                        openConsultIndex === 3 ? null : 3
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/consult?guide=Lifestyle & Residential Services`}
                                    >
                                      Lifestyle & Residential Services
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openConsultIndex === 3
                                          ? faMinus
                                          : faPlus
                                      }
                                    />
                                  </div>
                                  {openConsultIndex === 3 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/consult?guide=Community & Event Services`}
                                        >
                                          Community & Event Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Housekeeping & Maintenance`}
                                        >
                                          Housekeeping & Maintenance
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Fitness & Recreation`}
                                        >
                                          Fitness & Recreation
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Gardening & Landscaping`}
                                        >
                                          Gardening & Landscaping
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>

                                {/* Item 4 (no submenu) */}
                                <li>
                                  <div
                                    className="list-submenu"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenConsultIndex(
                                        openConsultIndex === 4 ? null : 4
                                      );
                                    }}
                                  >
                                    <Link
                                      to={`/consult?guide=Specialized & Emergency Services`}
                                    >
                                      Specialized & Emergency Services
                                    </Link>
                                    <FontAwesomeIcon
                                      icon={
                                        openConsultIndex === 4
                                          ? faMinus
                                          : faPlus
                                      }
                                    />
                                  </div>
                                  {openConsultIndex === 4 && (
                                    <ul className="submenu-columns">
                                      <li>
                                        <Link
                                          to={`/consult?guide=Animal & Pest Services`}
                                        >
                                          Animal & Pest Services
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Repair & Emergency Solutions`}
                                        >
                                          Repair & Emergency Solutions
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/consult?guide=Professional Services`}
                                        >
                                          Professional Services
                                        </Link>
                                      </li>
                                    </ul>
                                  )}
                                </li>
                              </ul>
                            )}
                          </div>
                          <li>
                            <Link to="/about-us">About</Link>
                          </li>
                          <li>
                            <Link to="/blogs">Blogs</Link>
                          </li>
                          <li>
                            <Link to="/faqs">Faqs</Link>
                          </li>
                          <li>
                            <Link to="contact-us">Contact Us</Link>
                          </li>
                          <li>
                            <Link to="/terms-condition">
                              Terms &amp; Conditions
                            </Link>
                          </li>
                          <li>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                          </li>
                          <li>
                            <Link to="/anti-discrimination-policy">
                              Anti-discrimination policy
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {!user?.isAuthenticated && (
                        <div className="button-wrraper-block">
                          <Link
                            to={"/vendor-login"}
                            className="btn vendor-login  d-lg-none"
                          >
                            <FontAwesomeIcon icon={faSuitcase} />{" "}
                            <span>For Vendors</span>
                          </Link>
                          <Link
                            to={"/login"}
                            className="btn customer-login  orange-outlined  d-lg-none"
                          >
                            <FontAwesomeIcon icon={faUser} />{" "}
                            <span>For Customers</span>
                          </Link>
                        </div>
                      )}
                      {user?.isAuthenticated && (
                        <div>
                          <Link
                            className="btn black-btn  orange-btn"
                            onClick={handleLogout}
                          >
                            Logout
                          </Link>
                        </div>
                      )}
                    </div>
                  </Sidebar>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
